var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"http404-container"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('el-button',{attrs:{"round":"","type":"primary"}},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }